import { CSS, StyleProps } from "../../styles"

export const container = (props: StyleProps): CSS => ({
  padding: props.theme.spacing(5),
})

export const text = (props: StyleProps): CSS => ({
  ...props.theme.fonts.body,
  fontSize: props.theme.fontSize.body,
  marginLeft: props.theme.spacing(2),
})
